(function () {
  // Partner starting prices (VAT inc) from pergolainstallations.co.uk — display only
  const INSTALL_FRAME = {
    small: {
      freestanding: { manual: 58000, electric: 61000 },
      wall: { manual: 63000, electric: 65000 },
    },
    large: {
      freestanding: { manual: 64500, electric: 68000 },
      wall: { manual: 68500, electric: 72000 },
    },
  };
  const INSTALL_HEATER = 4500;
  const INSTALL_LED = 5000;
  const INSTALL_SCREEN_MANUAL = { 3: 5500, 4: 6500, 5: 7500, 6: 8500 };
  const INSTALL_SCREEN_ELECTRIC = { 3: 9000, 4: 10000, 5: 11500, 6: 12500 };

  function parseSizeMetres(label) {
    if (!label) return [0, 0];
    const match = String(label)
      .replace(/×/g, "x")
      .match(/(\d+(?:\.\d+)?)\s*m?\s*x\s*(\d+(?:\.\d+)?)\s*m?/i);
    if (!match) return [0, 0];
    return [parseFloat(match[1]), parseFloat(match[2])];
  }

  function screenBandMetres(widthCm) {
    const metres = Number(widthCm) / 100;
    if (!Number.isFinite(metres) || metres <= 3) return 3;
    if (metres <= 4) return 4;
    if (metres <= 5) return 5;
    return 6;
  }

  function formatInstallFromPounds(cents) {
    const pounds = Math.round(Number(cents) / 100);
    return "from £" + pounds.toLocaleString("en-GB");
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }

  function parseMoneyFormat(format, cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const raw = String(format || "{{amount}}");
    return raw
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_with_currency\s*\}\}/g, withCommas);
  }

  function init(root) {
    if (!root || root.dataset.sunnierInit === "true") return;
    root.dataset.sunnierInit = "true";

    const heightAddon = root.dataset.heightAddon || "";
    const ledAddon = root.dataset.ledAddon || "";
    const heaterAddon = root.dataset.heaterAddon || "";
    const heightPrice = Number(root.dataset.heightPrice || "0");
    const ledPrice = Number(root.dataset.ledPrice || "0");
    const heaterPrice = Number(root.dataset.heaterPrice || "0");
    const moneyFormat = root.dataset.moneyFormat || "£{{amount}}";
    const standardHeight = Number(root.dataset.standardHeight || "2350");
    const step = Number(root.dataset.heightStep || "10");
    const heightMin = 2100;
    const heightMax = 2800;

    function clampHeight(mm) {
      const n = Number(mm);
      if (!Number.isFinite(n)) return standardHeight;
      return Math.min(heightMax, Math.max(heightMin, n));
    }
    const productTitle = root.dataset.productTitle || "Pergola Classic";
    const productHandle = root.dataset.productHandle || "";
    const roofType =
      (root.dataset.roofType || (/essential/i.test(productHandle || productTitle) ? "manual" : "electric"))
        .toLowerCase() === "manual"
        ? "manual"
        : "electric";
    const installPriceEls = qsa(root, "[data-sunnier-install-price]");

    let basePriceCents = Number(root.dataset.basePrice || "0");
    let variantPrices = {};
    let cachedVariantOptions = null;
    const priceJson = document.querySelector("[data-sunnier-variant-prices]");
    if (priceJson) {
      try {
        variantPrices = JSON.parse(priceJson.textContent || "{}");
      } catch (e) {
        variantPrices = {};
      }
    }

    const heightModeInputs = qsa(root, 'input[name="sunnier-height-mode"]');
    const heightInput = qs(root, "[data-sunnier-height-input]");
    const heightPanel = qs(root, "[data-sunnier-height-panel]");
    const assemblyInputs = qsa(root, 'input[name="sunnier-assembly"]');
    const installIntroPanel = qs(root, "[data-sunnier-install-intro]");
    const minusBtn = qs(root, "[data-sunnier-height-minus]");
    const plusBtn = qs(root, "[data-sunnier-height-plus]");
    const resetBtn = qs(root, "[data-sunnier-height-reset]");

    const mainProductInfo =
      document.querySelector("product-info.main-product-form") ||
      document.querySelector("product-info[id^='MainProduct']") ||
      document.querySelector("product-info");

    // Extras live outside the options root (below Mount)
    const extrasScope = mainProductInfo || document;
    const extraInputs = qsa(extrasScope, "[data-sunnier-extra]");

    // LED lighting is free this month — selected by default unless a share URL says otherwise
    const ledInput = extraInputs.find((el) => el.dataset.sunnierExtra === "led");

    function pad2(n) {
      return String(Math.max(0, n)).padStart(2, "0");
    }

    function endOfCurrentMonth(now) {
      return new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
    }

    function initLedCountdown() {
      const offer = qs(extrasScope, "[data-sunnier-led-countdown]");
      if (!offer) return;

      const monthEl = qs(offer, "[data-sunnier-led-month]");
      const daysEl = qs(offer, '[data-sunnier-cd="days"]');
      const hoursEl = qs(offer, '[data-sunnier-cd="hours"]');
      const minsEl = qs(offer, '[data-sunnier-cd="mins"]');
      const secsEl = qs(offer, '[data-sunnier-cd="secs"]');

      function tick() {
        const now = new Date();
        const end = endOfCurrentMonth(now);
        if (monthEl) {
          monthEl.textContent = end.toLocaleString("en-GB", { month: "long" });
        }

        let diff = end.getTime() - now.getTime();
        if (diff < 0) diff = 0;

        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const mins = Math.floor((diff % 3600000) / 60000);
        const secs = Math.floor((diff % 60000) / 1000);

        if (daysEl) daysEl.textContent = pad2(days);
        if (hoursEl) hoursEl.textContent = pad2(hours);
        if (minsEl) minsEl.textContent = pad2(mins);
        if (secsEl) secsEl.textContent = pad2(secs);
      }

      tick();
      if (offer._sunnierCountdown) clearInterval(offer._sunnierCountdown);
      offer._sunnierCountdown = setInterval(tick, 1000);
    }

    initLedCountdown();

    function cartForms() {
      const forms = new Set();
      if (mainProductInfo) {
        qsa(mainProductInfo, 'form[action*="/cart/add"], form[data-type="add-to-cart-form"]').forEach((f) =>
          forms.add(f)
        );
      }
      qsa(
        document,
        '.sticky-atc-bar form[action*="/cart/add"], #shopify-section-sticky-atc-bar form[action*="/cart/add"], form#product-form-sticky-atc-bar'
      ).forEach((f) => forms.add(f));
      if (!forms.size) {
        const fallback =
          document.querySelector('form[action*="/cart/add"]') ||
          document.querySelector("product-form form") ||
          document.querySelector("form.product-form");
        if (fallback) forms.add(fallback);
      }
      return Array.from(forms);
    }

    function selectedAssembly() {
      const checked = assemblyInputs.find((el) => el.checked);
      return checked ? checked.value : "Self assembly";
    }

    function wantsInstallIntro() {
      return selectedAssembly() === "Installation intro";
    }

    function assemblySummaryLabel() {
      return wantsInstallIntro()
        ? "Installer quote requested"
        : "Self assembly";
    }

    function selectedHeightMode() {
      const checked = heightModeInputs.find((el) => el.checked);
      return checked ? checked.value : "standard";
    }

    function heightMm() {
      if (!heightInput) return standardHeight;
      return Number(heightInput.value) || standardHeight;
    }

    function getMainVariantId() {
      const forms = cartForms();
      for (const form of forms) {
        // Prefer the main product form id input when available
        if (mainProductInfo && !mainProductInfo.contains(form) && forms.length > 1) continue;
        const idInput = form.querySelector('input[name="id"], select[name="id"], [name="id"]');
        if (idInput && idInput.value) return idInput.value;
      }
      for (const form of forms) {
        const idInput = form.querySelector('input[name="id"], select[name="id"], [name="id"]');
        if (idInput && idInput.value) return idInput.value;
      }
      return null;
    }

    function getQuantity() {
      if (!mainProductInfo) return 1;
      const qty = mainProductInfo.querySelector('input[name="quantity"]');
      return qty ? Math.max(1, Number(qty.value) || 1) : 1;
    }

    function formatMoney(cents) {
      if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === "function") {
        return FoxTheme.Currency.formatMoney(cents, moneyFormat);
      }
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return parseMoneyFormat(moneyFormat, cents);
    }

    function currentBasePrice() {
      const variantId = getMainVariantId();
      if (variantId && variantPrices[variantId] != null) {
        return Number(variantPrices[variantId]);
      }
      return basePriceCents;
    }

    function isExtraSelected(key) {
      const input = extraInputs.find((el) => el.dataset.sunnierExtra === key);
      return !!(input && input.checked);
    }

    function screensApi() {
      return window.SunnierPergolaScreens || null;
    }

    function installEstimateCents() {
      const [sideA, sideB] = parseSizeMetres(sizeLabel());
      const band = sideA >= 5 || sideB >= 5 ? "large" : "small";
      const mount = /wall/i.test(mountLabel()) ? "wall" : "freestanding";
      let total = INSTALL_FRAME[band][mount][roofType];

      if (isExtraSelected("led")) total += INSTALL_LED;
      if (isExtraSelected("heater")) total += INSTALL_HEATER;

      const screens = screensApi();
      if (screens && typeof screens.getInstallItems === "function") {
        screens.getInstallItems().forEach((item) => {
          const metres = screenBandMetres(item.widthCm);
          const table =
            String(item.drive || "").toLowerCase() === "manual"
              ? INSTALL_SCREEN_MANUAL
              : INSTALL_SCREEN_ELECTRIC;
          total += table[metres] || table[6];
        });
      }

      return total;
    }

    function installEstimateLabel() {
      return formatInstallFromPounds(installEstimateCents());
    }

    function updateInstallEstimate() {
      const label = installEstimateLabel();
      installPriceEls.forEach((el) => {
        if (el.textContent !== label) el.textContent = label;
      });
    }

    function totalPriceCents() {
      let total = currentBasePrice();
      // Installation is a partner intro only — never adds to Sunnier order total
      if (selectedHeightMode() === "custom") total += heightPrice;
      if (isExtraSelected("led")) total += ledPrice;
      if (isExtraSelected("heater")) total += heaterPrice;
      const screens = screensApi();
      if (screens && typeof screens.getExtraCents === "function") {
        total += screens.getExtraCents();
      }
      return total;
    }

    function sellingPriceNodes(scope) {
      if (!scope) return [];
      const wrappers = qsa(scope, ".f-price:not(.f-price--sold-out)");
      const nodes = [];
      wrappers.forEach((wrapper) => {
        const onSale = wrapper.classList.contains("f-price--on-sale");
        if (onSale) {
          const sale = wrapper.querySelector(".f-price__sale .f-price-item--sale, .f-price-item--sale");
          if (sale && !sale.querySelector("s")) nodes.push(sale);
        } else {
          // Sticky ATC writes current price into both sale + regular; update both
          // when not on sale so neither stays stale.
          const regular = wrapper.querySelector(
            ".f-price__regular .f-price-item--regular, .f-price-item--regular"
          );
          const sale = wrapper.querySelector(".f-price__sale .f-price-item--sale, .f-price-item--sale");
          if (regular && !regular.querySelector("s")) nodes.push(regular);
          if (sale && !sale.querySelector("s") && sale !== regular) nodes.push(sale);
        }
      });
      return nodes;
    }

    function priceTargets() {
      const targets = [];
      const seen = new Set();

      const mainScope =
        mainProductInfo ||
        document.querySelector(".product") ||
        document.querySelector('[id^="MainProduct"]');

      sellingPriceNodes(mainScope).forEach((el) => {
        if (!seen.has(el)) {
          seen.add(el);
          targets.push(el);
        }
      });

      // Sticky bar lives outside the product section
      const sticky =
        document.getElementById("shopify-section-sticky-atc-bar") ||
        document.querySelector(".sticky-atc-bar") ||
        document.querySelector("sticky-atc-bar");
      sellingPriceNodes(sticky).forEach((el) => {
        if (!seen.has(el)) {
          seen.add(el);
          targets.push(el);
        }
      });

      return targets;
    }

    let applyingPrice = false;

    function updateDisplayedPrice() {
      const formatted = formatMoney(totalPriceCents());
      applyingPrice = true;
      try {
        priceTargets().forEach((el) => {
          if (el.querySelector("s")) return;
          if (el.textContent.trim() === formatted.trim()) return;
          el.textContent = formatted;
        });
      } finally {
        // Allow mutation observer to settle after our write
        requestAnimationFrame(() => {
          applyingPrice = false;
        });
      }
    }

    function schedulePriceUpdate() {
      updateDisplayedPrice();
      requestAnimationFrame(() => {
        requestAnimationFrame(updateDisplayedPrice);
      });
      // Sticky ATC rewrite runs on the same variantChange pubsub — catch it after
      setTimeout(updateDisplayedPrice, 50);
      setTimeout(updateDisplayedPrice, 150);
      setTimeout(updateDisplayedPrice, 350);
    }

    function readVariantOptionsFromDom() {
      const scope = mainProductInfo || document;
      const script = scope.querySelector("variant-selects [data-selected-variant]");
      if (script) {
        try {
          const variant = JSON.parse(script.textContent || "null");
          if (variant && Array.isArray(variant.options) && variant.options.length) {
            return variant.options.map((value) => String(value).trim()).filter(Boolean);
          }
        } catch (e) {
          // fall through
        }
      }

      // One value per radio group — never scrape label text (can duplicate after morph)
      const parts = [];
      const seenNames = new Set();
      qsa(scope, "variant-selects input[type='radio']:checked").forEach((input) => {
        const key = input.name || input.id;
        if (!key || seenNames.has(key)) return;
        seenNames.add(key);
        const value = (input.value || "").trim();
        if (value) parts.push(value);
      });
      return parts;
    }

    function selectedVariantOptions() {
      if (cachedVariantOptions && cachedVariantOptions.length) {
        return cachedVariantOptions.slice();
      }
      const parts = readVariantOptionsFromDom();
      if (parts.length) cachedVariantOptions = parts.slice();
      return parts;
    }

    function buildConfigParts() {
      const parts = selectedVariantOptions();
      const mode = selectedHeightMode();
      if (mode === "custom") {
        parts.push("Custom height " + heightMm() + " mm");
      } else {
        parts.push("Standard height");
      }

      parts.push(assemblySummaryLabel());

      if (isExtraSelected("led")) parts.push("Perimeter LED (free)");
      if (isExtraSelected("heater")) parts.push("3kW heater");

      const screens = screensApi();
      if (screens && typeof screens.getSummaryParts === "function") {
        screens.getSummaryParts().forEach((part) => parts.push(part));
      }

      const cleaned = [];
      parts.filter(Boolean).forEach((part) => {
        if (cleaned[cleaned.length - 1] !== part) cleaned.push(part);
      });
      return cleaned;
    }

    function shareUrlPath() {
      const url = new URL(location.href);
      ["design_saved", "contact_posted", "v"].forEach((key) => url.searchParams.delete(key));

      if (selectedHeightMode() === "custom") {
        url.searchParams.set("h", "c" + heightMm());
      } else {
        url.searchParams.delete("h");
      }

      if (wantsInstallIntro()) url.searchParams.set("a", "quote");
      else url.searchParams.delete("a");

      if (!isExtraSelected("led")) url.searchParams.set("led", "0");
      else url.searchParams.delete("led");

      if (isExtraSelected("heater")) url.searchParams.set("ht", "1");
      else url.searchParams.delete("ht");

      const screens = screensApi();
      const serialized =
        screens && typeof screens.serialize === "function" ? screens.serialize() : "";
      if (serialized) url.searchParams.set("sc", serialized);
      else url.searchParams.delete("sc");

      return url.pathname + url.search + url.hash;
    }

    function writeShareUrl() {
      const next = shareUrlPath();
      if (next === location.pathname + location.search + location.hash) return;
      history.replaceState({}, "", next);
    }

    function applyFromUrl() {
      const params = new URLSearchParams(location.search);
      const heightParam = params.get("h");
      if (heightParam) {
        const customMatch = String(heightParam).match(/^c(\d+)$/i);
        if (customMatch) {
          const custom = heightModeInputs.find((el) => el.value === "custom");
          if (custom) custom.checked = true;
          if (heightInput) heightInput.value = String(clampHeight(customMatch[1]));
        } else {
          const standard = heightModeInputs.find((el) => el.value === "standard");
          if (standard) standard.checked = true;
        }
      }

      if (params.get("a") === "quote") {
        const quote = assemblyInputs.find((el) => el.value === "Installation intro");
        if (quote) quote.checked = true;
      }

      const ledParam = params.get("led");
      if (ledInput && (ledParam === "0" || ledParam === "1")) {
        ledInput.checked = ledParam !== "0";
        ledInput.dataset.sunnierUserTouched = "true";
      }

      const heaterInput = extraInputs.find((el) => el.dataset.sunnierExtra === "heater");
      if (heaterInput && params.get("ht") === "1") {
        heaterInput.checked = true;
        heaterInput.dataset.sunnierUserTouched = "true";
      }

      const screensParam = params.get("sc");
      const screens = screensApi();
      if (screensParam && screens && typeof screens.applySerialized === "function") {
        screens.applySerialized(screensParam);
      }
    }

    function updateConfigSummary() {
      const text = buildConfigParts().join(" · ");
      const target = qs(root, "[data-sunnier-config-summary-text]");
      if (target) target.textContent = text;

      qsa(document, "[data-sunnier-sticky-config]").forEach((el) => {
        el.textContent = text;
      });
      writeShareUrl();
    }

    function syncLabels() {
      qsa(root, ".sunnier-pergola-card").forEach((card) => {
        const input = card.querySelector("input");
        card.classList.toggle("is-selected", !!(input && input.checked));
      });

      qsa(extrasScope, ".sunnier-extra-card").forEach((card) => {
        const input = card.querySelector("input");
        card.classList.toggle("is-selected", !!(input && input.checked));
      });

      const custom = selectedHeightMode() === "custom";
      if (heightPanel) heightPanel.hidden = !custom;
      if (heightInput) {
        heightInput.disabled = !custom;
        if (!custom) heightInput.value = String(standardHeight);
      }
      if (installIntroPanel) installIntroPanel.hidden = !wantsInstallIntro();
      updateInstallEstimate();
      schedulePriceUpdate();
      updateConfigSummary();
    }

    function newBundleId() {
      if (window.crypto && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
      }
      return "pergola-" + Date.now() + "-" + Math.random().toString(16).slice(2);
    }

    function addonProps(type, extra) {
      return Object.assign(
        {
          "Addon type": type,
          For: productTitle,
          _sunnier_bundle: extra.bundleId,
          _sunnier_bundle_addon: "1",
        },
        extra.more || {}
      );
    }

    async function addConfiguredItems() {
      const variantId = getMainVariantId();
      if (!variantId) throw new Error("Variant not selected");

      const mode = selectedHeightMode();
      const mm = String(heightMm());
      const heightType = mode === "standard" ? "Standard" : "Custom";
      const bundleId = newBundleId();
      const ledSelected = isExtraSelected("led");
      const installIntro = wantsInstallIntro();

      const parentProperties = {
        Assembly: "Self assembly",
        Height: mm + " mm",
        "Height type": heightType,
        _sunnier_bundle: bundleId,
        _sunnier_bundle_parent: "1",
      };

      if (installIntro) {
        const estimate = installEstimateLabel();
        parentProperties["Professional installation intro"] = "Yes";
        parentProperties["Estimated installation"] = estimate;
        parentProperties["Installation note"] =
          "Independent partner will quote separately — not charged by Sunnier";
      }

      // Free LED stays on the pergola line (no £0 cart orphan)
      if (ledSelected) {
        parentProperties["Perimeter LED"] = "Included free (was £420)";
      }

      const items = [
        {
          id: Number(variantId),
          quantity: getQuantity(),
          properties: parentProperties,
        },
      ];

      if (mode === "custom" && heightAddon) {
        items.push({
          id: Number(heightAddon),
          quantity: 1,
          properties: addonProps("Custom height", {
            bundleId,
            more: { "Height (mm)": mm },
          }),
        });
      }

      if (isExtraSelected("heater") && heaterAddon) {
        items.push({
          id: Number(heaterAddon),
          quantity: 1,
          properties: addonProps("3kW Black Heater", { bundleId }),
        });
      }

      const screens = screensApi();
      if (screens && typeof screens.getCartItems === "function") {
        screens.getCartItems(bundleId).forEach((item) => items.push(item));
      }

      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || "Could not add to cart");
      }

      // Cart attribute for ops / partner handoff (no money attached)
      await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          attributes: {
            "Professional installation intro": installIntro ? "Yes" : "No",
            "Estimated installation": installIntro ? installEstimateLabel() : "",
          },
        }),
      }).catch(() => null);

      return response.json();
    }

    function bindFormSubmit(form) {
      if (!form || form.dataset.sunnierBound === "true") return;
      form.dataset.sunnierBound = "true";
      form.addEventListener(
        "submit",
        async (event) => {
          event.preventDefault();
          event.stopPropagation();
          try {
            await addConfiguredItems();
            window.location.href = window.Shopify.routes.root + "cart";
          } catch (error) {
            console.error(error);
            alert(error.message || "Unable to add to cart");
          }
        },
        true
      );
    }

    function bindAllForms() {
      cartForms().forEach(bindFormSubmit);
    }

    heightModeInputs.forEach((input) =>
      input.addEventListener("change", syncLabels)
    );
    assemblyInputs.forEach((input) =>
      input.addEventListener("change", syncLabels)
    );
    extraInputs.forEach((input) =>
      input.addEventListener("change", syncLabels)
    );

    if (minusBtn && heightInput) {
      minusBtn.addEventListener("click", (event) => {
        event.preventDefault();
        if (selectedHeightMode() !== "custom") return;
        heightInput.value = String(clampHeight(Number(heightInput.value) - step));
        schedulePriceUpdate();
        updateConfigSummary();
      });
    }
    if (plusBtn && heightInput) {
      plusBtn.addEventListener("click", (event) => {
        event.preventDefault();
        if (selectedHeightMode() !== "custom") return;
        heightInput.value = String(clampHeight(Number(heightInput.value) + step));
        schedulePriceUpdate();
        updateConfigSummary();
      });
    }
    if (heightInput) {
      heightInput.addEventListener("change", () => {
        heightInput.value = String(clampHeight(heightInput.value));
        schedulePriceUpdate();
        updateConfigSummary();
      });
      heightInput.addEventListener("input", () => {
        schedulePriceUpdate();
        updateConfigSummary();
      });
      heightInput.addEventListener("blur", () => {
        heightInput.value = String(clampHeight(heightInput.value));
        schedulePriceUpdate();
        updateConfigSummary();
      });
    }

    document.addEventListener("sunnier:screens-changed", () => {
      updateInstallEstimate();
      schedulePriceUpdate();
      updateConfigSummary();
    });
    if (resetBtn) {
      resetBtn.addEventListener("click", (event) => {
        event.preventDefault();
        const standard = heightModeInputs.find((el) => el.value === "standard");
        if (standard) standard.checked = true;
        if (heightInput) heightInput.value = String(standardHeight);
        syncLabels();
      });
    }

    function onVariantChanged(variant) {
      if (variant && variant.price != null) {
        basePriceCents = Number(variant.price);
        if (variant.id != null) variantPrices[variant.id] = Number(variant.price);
      }
      if (variant && Array.isArray(variant.options) && variant.options.length) {
        cachedVariantOptions = variant.options.map((value) => String(value).trim()).filter(Boolean);
      } else {
        cachedVariantOptions = readVariantOptionsFromDom();
      }
      updateInstallEstimate();
      schedulePriceUpdate();
      updateConfigSummary();
      // Sticky form may appear / sync after variant change
      bindAllForms();
    }

    document.addEventListener("variant:changed", (event) => {
      const variant = event.detail && event.detail.variant;
      onVariantChanged(variant);
    });

    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      try {
        FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          (event) => {
            const variant = event && event.data && event.data.variant;
            onVariantChanged(variant);
          }
        );
      } catch (e) {
        // ignore pubsub issues
      }
    }

    // Re-apply when sticky ATC overwrites price with base variant amount
    const stickyRoot =
      document.getElementById("shopify-section-sticky-atc-bar") ||
      document.querySelector(".sticky-atc-bar");
    if (stickyRoot && typeof MutationObserver !== "undefined") {
      const observer = new MutationObserver(() => {
        if (applyingPrice) return;
        const expected = formatMoney(totalPriceCents()).trim();
        const mismatch = priceTargets().some((el) => {
          if (el.querySelector("s")) return false;
          const text = el.textContent.trim();
          return text && text !== expected;
        });
        if (mismatch) updateDisplayedPrice();
      });
      observer.observe(stickyRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    extraInputs.forEach((input) => {
      input.addEventListener("change", () => {
        input.dataset.sunnierUserTouched = "true";
      });
    });

    const copyBtn = qs(root, "[data-sunnier-copy-config]");
    if (copyBtn) {
      copyBtn.addEventListener("click", async () => {
        writeShareUrl();
        const href = location.href;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(href);
          } else {
            const ta = document.createElement("textarea");
            ta.value = href;
            ta.setAttribute("readonly", "");
            ta.style.position = "fixed";
            ta.style.left = "-9999px";
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            ta.remove();
          }
          copyBtn.textContent = "Copied";
          window.setTimeout(() => {
            copyBtn.textContent = "Copy link";
          }, 1600);
        } catch (e) {
          copyBtn.textContent = "Copy failed";
          window.setTimeout(() => {
            copyBtn.textContent = "Copy link";
          }, 1600);
        }
      });
    }

    bindAllForms();

    // Sticky ATC may connect after us
    setTimeout(bindAllForms, 300);
    setTimeout(bindAllForms, 1000);

    function sizeLabel() {
      const opts = selectedVariantOptions();
      return opts.find((v) => /\d+\s*m\s*x/i.test(v)) || opts[0] || "";
    }

    function colourLabel() {
      const opts = selectedVariantOptions();
      return opts.find((v) => /anthracite|white|ral|mix/i.test(v)) || opts[1] || "";
    }

    function mountLabel() {
      const opts = selectedVariantOptions();
      return opts.find((v) => /freestanding|wall/i.test(v)) || opts[2] || "";
    }

    function configSnapshot() {
      const extras = [];
      if (isExtraSelected("led")) extras.push("Perimeter LED");
      if (isExtraSelected("heater")) extras.push("3kW heater");
      const screens = screensApi();
      if (screens && typeof screens.getSummaryParts === "function") {
        screens.getSummaryParts().forEach((part) => extras.push(part));
      }
      const actions = document.querySelector("[data-sunnier-buy-actions]");
      return {
        product: (actions && actions.dataset.productTitle) || productTitle,
        handle:
          (actions && actions.dataset.productHandle) ||
          (location.pathname.split("/products/")[1] || "").split("?")[0],
        size: sizeLabel(),
        colour: colourLabel(),
        mount: mountLabel(),
        height:
          selectedHeightMode() === "custom"
            ? "Custom " + heightMm() + " mm"
            : "Standard " + standardHeight + " mm",
        assembly: assemblySummaryLabel(),
        extras: extras.join(", ") || "None",
        summary: buildConfigParts().join(" · "),
        totalCents: totalPriceCents(),
        installEstimateCents: installEstimateCents(),
        url: location.origin + shareUrlPath(),
      };
    }

    window.SunnierPergolaConfig = {
      getHeightMm: heightMm,
      getTotalCents: totalPriceCents,
      getInstallEstimateCents: installEstimateCents,
      getSizeLabel: sizeLabel,
      getColourLabel: colourLabel,
      getMountLabel: mountLabel,
      getConfigSnapshot: configSnapshot,
    };

    applyFromUrl();
    if (ledInput && !ledInput.dataset.sunnierUserTouched) {
      ledInput.checked = true;
    }
    syncLabels();
    document.dispatchEvent(new CustomEvent("sunnier:config-ready", { bubbles: true }));
  }

  function boot() {
    qsa(document, "[data-sunnier-pergola-options]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
